import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import EditButton from 'components/interaction/EditButton.js';
import SelectLocationType from './index.jsx';
import { LOCATION_TYPE_LABEL } from './constants.js';

const SelectWrapper = styled.div`
  position: absolute;
  top: 0;
  left: -8px;
  background-color: white;
  border-radius: 16px;
  z-index: 1;
`;

function ShowLocationType(props) {
  const { value, onEdit, showEdit, disabled, title, ...rest } = props;
  // eslint-disable-next-line eqeqeq
  const label = LOCATION_TYPE_LABEL[value];
  if (!onEdit) {
    return <FormattedMessage {...label} />;
  }
  return (
    <div className="position-relative">
      <span className="text-nowrap">
        {label && <FormattedMessage {...label} />}
        <EditButton onClick={onEdit} disabled={disabled} title={title} className="ms-2" />
      </span>
      {showEdit && (
        <SelectWrapper>
          <SelectLocationType
            autoFocus
            value={value}
            {...rest}
          />
        </SelectWrapper>
      )}
    </div>
  );
}

ShowLocationType.propTypes = {
  value: PropTypes.any,
  showEdit: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  onEdit: PropTypes.func,
  onChange: PropTypes.func,
};

export default ShowLocationType;
